// «Skriv ut prisoverslag» på en bestilling i klubbinfo (prisoverslagUtskrift.js): velg hvem i klubben det er
// til (eller bare klubben), og skriv ut eller lagre som PDF fra utskriftsvinduet. Brukes på
// bestillingen og i skjemaet mens den skrives (da med varene som ikke er lagret ennå).
import React, { useId, useState } from 'react';
import Cookies from 'js-cookie';
import Ikon from '../../ny-kundesamhandling/Ikon';
import { Valgfelt } from '../../ny-kundesamhandling/Skjema';
import { rolleNavn, sarIdrettNavn } from './klubbApi';
import { skrivUtPrisoverslag } from './prisoverslagUtskrift';

const liteKnapp =
  'inline-flex min-h-[2.25rem] items-center gap-1.5 rounded-xl border-2 border-slate-200 bg-white px-2.5 py-1 text-sm font-semibold text-slate-800 hover:bg-slate-50 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-600/50';

const harPris = (l) => Number(String(l.pris ?? '').replace(',', '.')) > 0;

export default function Prisoverslag({ klubb, innlegg }) {
  const id = useId();
  const [apen, setApen] = useState(false);
  const [personId, setPersonId] = useState('');
  const [feil, setFeil] = useState('');
  const linjer = innlegg.prislinjer || [];
  // Personer i samme særidrett som bestillingen først, så resten.
  const sar = innlegg.sarIdrettId || '';
  const personer = [...(klubb.personer || [])].sort(
    (a, b) => (Number((b.sarIdrettId || '') === sar) - Number((a.sarIdrettId || '') === sar)) || a.navn.localeCompare(b.navn, 'nb')
  );

  function skrivUt() {
    setFeil('');
    if (!linjer.length) return setFeil('Legg til varer først.');
    if (linjer.some((l) => !harPris(l))) return setFeil('Sett pris på alle varene før du skriver ut.');
    const person = personer.find((p) => p._id === personId) || null;
    const ok = skrivUtPrisoverslag({ klubb, innlegg, person, ansatt: Cookies.get('selectedEmployee') || '' });
    if (!ok) setFeil('Nettleseren stoppet utskriftsvinduet. Tillat sprettoppvinduer for denne siden og prøv igjen.');
  }

  if (!apen) {
    return (
      <button type="button" onClick={() => setApen(true)} className={liteKnapp} disabled={!linjer.length}>
        <Ikon navn="dokument" className="w-4 h-4" /> Skriv ut prisoverslag<span className="sr-only">: {innlegg.tittel}</span>
      </button>
    );
  }
  return (
    <div role="group" aria-labelledby={`${id}-t`} className="w-full space-y-2 rounded-xl border border-sky-300 bg-sky-50 p-2.5">
      <p id={`${id}-t`} className="font-semibold text-slate-900">Prisoverslag til {klubb.navn}</p>
      <p className="text-sm text-slate-700">
        A4 med varene, trykket, prisene og summen inkl. mva, uten kostpris og dekningsbidrag. Velg «Lagre som PDF» i utskriftsvinduet
        for å legge det ved en e-post.
      </p>
      <Valgfelt id={`${id}-til`} etikett="Til" value={personId} onChange={(e) => setPersonId(e.target.value)}>
        <option value="">Bare klubben (ingen bestemt person)</option>
        {personer.map((p) => (
          <option key={p._id} value={p._id}>
            {p.navn} – {rolleNavn(p.rolle)}, {sarIdrettNavn(klubb, p.sarIdrettId) || 'hele klubben'}
          </option>
        ))}
      </Valgfelt>
      {feil && <p role="alert" className="font-semibold text-rose-800">{feil}</p>}
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={skrivUt} className={liteKnapp}>
          <Ikon navn="dokument" className="w-4 h-4" /> Skriv ut
        </button>
        <button type="button" onClick={() => { setApen(false); setFeil(''); }} className={liteKnapp}>Lukk</button>
      </div>
    </div>
  );
}
